export enum TrackEvent {
  ROOM_SESSION_OPENED = 'Room Session Opened',
  ROOM_SESSION_RENAMED = 'Room Session Renamed',
  ROOM_SESSION_DELETED = 'Room Session Deleted',
  AI_RESULT_OPENED = 'AI Result Opened',
  ALL_AI_RESULTS_COPIED = 'All AI Results Copied',
  AI_RESULT_COPIED = 'AI Result Copied',
  AI_RESULT_SCORED = 'AI Result Scored',
  AI_RESULT_DISMISSED = 'AI Result Dismissed',
  AI_RESULT_ACCEPTED = 'AI Result Accepted',
  AI_RESULT_EMAIL_CLICKED = 'AI Result Email Clicked',
  AI_RESULT_OVERRIDE = 'AI Result Override Started',
  AI_ASK_ME_ANYTHING_EXECUTED = 'AI Ask Me Anything Executed',
  AI_FEATURE_RERUN = 'AI Feature Rerun',
  AI_FEATURE_MANUAL_RUN = 'AI Feature Manual Run',
  AI_SYSTEM_PRESET_RUN = 'AI System Preset Run',
  RERUN_AI_RESULT_SAVED = 'Rerun AI Result Saved',
  RERUN_AI_RESULT_REPLACED = 'Rerun AI Result Replaced',
  ON_DEMAND_AI_FEATURES_EXECUTED = 'On-demand AI Features Executed',
  UPLOAD_RECORDING_CLICKED = 'Upload Recording Clicked',
  RECORDING_UPLOADED = 'Recording Uploaded',
  DYNAMIC_AI_FEATURE_EXECUTED = 'AI feature with dynamic context executed',
  SHARE_BUTTON_CLICKED = 'Share Meeting Button Clicked',
  NEW_ALLOCATION_SAVED = 'New Allocation Saved',
  ROOM_SESSION_PROCESSED = 'Meeting Processed',
  ROOM_SESSION_UNPROCESSED = 'Meeting Unprocessed',
  ROOM_SESSION_MEETING_TYPE_CHANGED = 'Meeting Type Changed',
  NOTEPAD_OPENED = 'Notepad Opened',
  AI_RESULT_ADDED_TO_NOTEPAD = 'AI Result Added To Notepad',
  COMMENTS_OPENED = 'Comments Opened',
  AI_RESULT_COMMENTED = 'AI Result Commented',
  AI_RESULT_EXPLAINED = 'AI Result Explained',
  SWITCHED_TO_SUMMARY_V1 = 'Switched To Meeting Summary V1',
  SWITCHED_TO_SUMMARY_V2 = 'Switched To Meeting Summary V2',
  ROOM_SESSION_ENDED = 'Room Session Ended',
  EXPORT_TO_PDF = 'Export to PDF',
  EVENT_FILTER_CHANGED = 'Event Filter Changed',
  AI_ASSISTANT_ADDED = 'AI Assistant Added',
  CHANGED_TO_IN_PERSON = 'Changed To In-Person',
  CHANGED_PRIVACY = 'Changed Session Privacy',
  CHANGED_TO_PHONE = 'Changed To Phone',
  MENU_ITEM_CLICKED = 'Menu Item Clicked',

  //FORM
  FORM_MANUALLY_EXECUTED = 'Form Manually Executed',
  FORM_RESULT_EDITED = 'Form Result Edited',
  SAVE_FORM_TO_CRM = 'Save form result to CRM Clicked',
  FORM_CREATED = 'New form created',
  FORM_UPDATED = 'Form updated',
  FORM_CLONED = 'Form cloned',
  FORM_RERUN = 'Form Rerun',
  CONTACT_FORM_FILL_OPENED = 'Contact Form Fill Opened',
  CONTACT_FORM_RERUN = 'Contact Form Rerun',
  CONTACT_FORM_EXECUTED = 'Contact Form Executed',
  FORM_CITATION_GENERATED = 'Form Citation Generated',
  FORM_CITATION_CLICKED = 'Form Citation Clicked',
  FORM_RESULT_EXPLAINED = 'Form Result Explained',

  // PLAN EVENTS
  PLAN_PERIOD_CHANGE = 'Plan Period Changed',
  PLAN_MANAGE_PLAN_OPENED = 'Plan Manage Plan Opened',
  PLAN_UPGRADE_PLAN_OPENED = 'Plan Upgrade Plan Opened',
  PLAN_UPGRADE_SEAT_OPENED = 'Plan Upgrade Seat Opened',
  PLAN_UPGRADE_ASSISTANT_SEAT_OPENED = 'Plan Upgrade Assistant Seat Opened',
  PLAN_ENTERPRISE_OPENED = 'Plan Enterprise Opened',
  PLAN_BILLING_HISTORY_OPENED = 'Plan Billing History Opened',
  PLAN_UPGRADE_PLAN_CHANGED = 'Plan Upgrade Plan Changed',
  PLAN_UPGRADE_SEAT_CHANGED = 'Plan Upgrade Seat Changed',
  PLAN_UPGRADE_ASSISTANT_SEAT_CHANGED = 'Plan Upgrade Assistant Seat Changed',
  PLAN_TRY_FOR_FREE_CLICK = 'Try For Free Clicked',
  PLAN_UPGRADE_CLICKED = 'Plan Upgrade Clicked',
  PLAN_DELTA_TRAL_STARTED = 'Plan Delta Tral Started',
  PLAN_DELTA_TRAL_CANCELED = 'Plan Delta Tral Canceled',

  //Manage Team
  INVITE_USER_CLICKED = 'Invite user clicked',
  BULK_INVITE_USER_CLICKED = 'Bulk Invite clicked',
  INVITE_USER_SENT = 'Invite user sent',

  // Contacts
  ADD_CONTACT_CLICKED = 'Add contact clicked',
  CONTACT_ADDED = 'Contact added',
  CONTACT_TAB_CHANGED = 'Contact Tab Changed',

  //Setup
  PRESET_INSTALL_CLICKED = 'Preset Install Clicked',
  PRESET_UNINSTALL_CLICKED = 'Preset Uninstall Clicked',
  PRESET_FILTER_CLICKED = 'Preset Filter Clicked',
  PRESET_CONFIG_CLICKED = 'Preset Config CLicked',

  //Meeting scorecard
  MEETING_SCORECARD_SWITCHED = 'Meeting Scorecard Switched',

  // Meeting template
  MEETING_TEMPLATE_ACTIVATED = 'Meeting Template Activated',
  MEETING_TEMPLATE_DEACTIVATED = 'Meeting Template Deactivated',
  MEETING_TEMPLATE_CREATED = 'Meeting Template Created',
  MEETING_TEMPLATE_CREATED_FROM_SYSTEM = 'Meeting Template Created From System',
  MEETING_TEMPLATE_UPDATED = 'Meeting Template Updated',
  MEETING_TEMPLATE_COPIED = 'Meeting Template Copied',

  // Email type
  EMAIL_TYPE_ACTIVATED = 'Email Type Activated',
  EMAIL_TYPE_DEACTIVATED = 'Email Type Deactivated',
  EMAIL_TYPE_CREATED = 'Email Type Created',
  EMAIL_TYPE_CREATED_FROM_SYSTEM = 'Email Type Created From System',
  EMAIL_TYPE_UPDATED = 'Email Type Updated',
  EMAIL_TYPE_COPIED = 'Email Type Copied',

  //Profile Settings
  DELETE_MY_ACCOUNT_CLICKED = 'Delete My Account Clicked',
  ZOOM_CONNECT_CLICKED = 'Zoom Connect Clicked',
  ZOOM_DISCONNECT_CLICKED = 'Zoom Disconnect Clicked',
  ZOOM_SETTINGS_OPENED = 'Zoom Settings Opened',
  ZOOM_SETTINGS_SAVED = 'Zoom Settings Saved',
  NOTIFICATION_REQUESTED = 'notification-requested',

  //Share Zocks
  SHARE_ZOCKS_MODAL_OPEN = 'Share Zocks Opened',
  SHARE_ZOCKS_ON_SOCIAL = 'Share Zocks On Social Clicked',

  //In Person Meeting App
  IN_PERSON_MEETING_STARTED = 'In Person Meeting Started',
  IN_PERSON_MEETING_START_ERROR = 'In Person Meeting Start Error Encountered',
  IN_PERSON_MEETING_FINISHED = 'In Person Meeting Finished',
  ABORTED_IN_PERSON_MEETING_FINISHED = 'Aborted In Person Meeting Finished',
  IN_PERSON_MEETING_PAUSED = 'In Person Meeting Paused',
  IN_PERSON_MEETING_RESUMED = 'In Person Meeting Resumed',
  IN_PERSON_MEETING_CHUNK_UPLOAD_FAILED = 'In Person Meeting Chunk Upload Failed',
  IN_PERSON_MEETING_FINISHING_ERROR = 'In Person Meeting Finish Error Encountered',

  //CRM
  SAVE_MEETING_TO_CRM = 'Save meeting to CRM Clicked',
  SAVE_MEETING_SUMMARY_TO_CRM = 'Save meeting summary to CRM Clicked',
  SAVE_TASKS_TO_CRM = 'Save tasks to CRM Clicked',
  SAVE_NOTES_TO_CRM = 'Save notes to CRM Clicked',
  SAVE_EVENTS_TO_CRM = 'Save events to CRM Clicked',
  SAVE_RESULTS_TO_CRM = 'Save results to CRM Clicked',
  START_NEW_WORKFLOW_IN_CRM = 'Start new workflow in CRM clicked',
  UPDATE_WORKFLOW_STEP_IN_CRM = 'Update workflow step in CRM clicked',
  NOTIFY_USER_UTILIZED = 'Notify user utilized',
  MEETING_SUMMARY_EDITED_IN_MODAL = 'Meeting summary edited in modal',
  MEETING_EXPORT_EDITED = 'Meeting export edited',
  EXTERNAL_UPDATES_OPENED = 'External Updates Opened',
  CRM_LINK_CLICKED = 'CRM Link Clicked',

  // Integrations
  CONTACT_LINKED_TO_INTEGRATION = 'Contact Linked To Integration',
  SYNC_HISTORY_OPENED = 'Sync History Opened',
  CONNECT_TO_SYSTEM = 'Connect to system',
  INTEGRATION_CONFIG_EMAIL_FIELD_FILLED = 'Integration config email field filled',
  INTEGRATION_CONFIG_HOUSEHOLD_FIELD_FILLED = 'Integration config household field filled',
  INTEGRATION_CONFIG_SAVE_TO_HOUSEHOLD_TOGGLED = 'Integration config save to household toggled',
  INTEGRATION_CONFIG_SESSION_OBJECT_MODIFIED = 'Integration config session object modified',
  INTEGRATION_CONFIG_CONTACT_OBJECT_MODIFIED = 'Integration config contact object modified',

  // Tasks
  TASK_CREATED = 'Task Created',
  TASKS_MERGED = 'Tasks merged',
  TASK_UPDATED = 'Task Updated',

  // Meeting Prep
  MEETING_PREP_OPENED = 'Meeting Prep Opened',
  MEETING_PREP_INTERACTED_WITH = 'Meeting Prep Interacted With',
  MEETING_PREP_COPIED = 'Meeting Prep Copied',
  MEETING_PREP_EMAIL_COPIED = 'Meeting Prep E-mail Copied',
  MEETING_PREP_RERUN = 'Meeting Prep Rerun',
  MEETING_PREP_MAILTO_CLICKED = 'Meeting Prep Mailto Clicked',
  MEETING_PREP_EXECUTED_ON_CONTACT = 'Meeting prep executed on contact',
  MEETING_PREP_EXECUTED_FROM_UPCOMING = 'Meeting prep executed from Upcoming',
  MEETING_PREP_EDITED_MANUALLY = 'Meeting prep edited manually',
  MEETING_PREP_TAB_CHANGED = 'Meeting Prep Tab Changed',

  //Suggested Workflow
  SUGGESTED_WORKFLOW_RERUN = 'Suggested Workflow Rerun',

  // CRM Contact Update
  CRM_CONTACT_UPDATE_OPENED = 'CRM Contact Update Opened',
  CRM_CONTACT_UPDATE_RERUN = 'CRM Contact Update Rerun',
  CRM_CONTACT_UPDATE_SAVED = 'CRM Contact Update Saved',
  CRM_CONTACT_UPDATE_FIELD_SELECTED = 'CRM Contact Update Field Selected',
  CONTACT_UPDATE_SECTIONS_UNCHECKED = 'Contact update sections unchecked',
  CONTACT_UPDATE_RESULTS_CREATED = 'Contact update results created',
  CONTACT_UPDATE_RESULTS_EDITED = 'Contact update results edited',
  EXTERNAL_CONTACT_CREATED = 'External Contact Created',

  // Meeting Summary
  MEETING_SUMMARY_TAB_CHANGED = 'Meeting Summary Tab Changed',
  MEETING_SUMMARY_AGENT_INTERACT = 'Meeting Summary Agent Interact',
  MEETING_SUMMARY_AGENT_INTERACT_STREAMING = 'Meeting Summary Agent Interact (Streaming)',
  MEETING_SUMMARY_AGENT_RERUN = 'Meeting Summary Agent Rerun',
  MEETING_SUMMARY_AGENT_RESULT_COPIED = 'Meeting Summary Agent Result Copied',
  MEETING_SUMMARY_AGENT_CHAT_CLICKED = 'Meeting Summary Agent Chat Clicked',
  MEETING_SUMMARY_AGENT_FEATURE_PIN_CLICKED = 'Meeting Summary Agent Feature Pin Clicked',
  MEETING_SUMMARY_FIND_AND_REPLACE = 'Meeting Summary Find and Replace',

  // Email Response
  EMAIL_RESPONSE_OPENED = 'Email Response Opened',
  EMAIL_RESPONSE_EXECUTED = 'Email Response Executed',
  EMAIL_RESPONSE_INTERACTED_WITH = 'Email Response Interacted With',
  EMAIL_RESPONSE_COPIED = 'Email Response Copied',
  EMAIL_RESPONSE_MAILTO_CLICKED = 'Email Response Mailto Clicked',
  EMAIL_RESPONSE_PUSHED_TO_DRAFT = 'Email Response Pushed To Draft',
  EMAIL_RESPONSE_SENT = 'Email Response Sent',
  EMAIL_RESPONSE_EMAIL_TYPE_CHANGED = 'Email Response Email Type Changed',
  EMAIL_CONSENT_SETTINGS_CHANGED = 'Email Consent Settings Changed',
  EMAIL_AUTOMATION_SETTINGS_CHANGED = 'Email Automation Settings Changed',
  EMAIL_AUTOMATION_USER_SETTINGS_CHANGED = 'Email Automation User-Level Settings Changed',
  EMAIL_AUTOMATION_UNCATEGORIZED_ACTION_CHANGED = 'Email Automation Uncategorized Action Changed',
  EMAIL_CLIENT_PROFILE_CHANGES_OPENED = 'Email Profile Changes Opened',
  EMAIL_CONTACT_UPDATE_OPENED = 'Email Contact Update Opened',

  // Phone
  PHONE_START_CALL = 'Phone Start Call',
  PHONE_ADD_TO_ONGOING_CALL = 'Phone Add to Ongoing Call',

  // Citation
  CITATION_OPENED = 'Citation Opened',
  // Client-profile
  CLIENT_PROFILE_INITIAL_CRM_SYNC_EXECUTED = 'Client Profile Initial CRM Sync Executed',

  // New Email

  NEW_EMAIL_OPENED = 'New Email Opened',
  NEW_EMAIL_EXECUTED = 'New Email Executed',
  NEW_EMAIL_INTERACTED_WITH = 'New Email Interacted With',
  NEW_EMAIL_COPIED = 'New Email Copied',
  NEW_EMAIL_MAILTO_CLICKED = 'New Email Mailto Clicked',
  NEW_EMAIL_PUSHED_TO_DRAFT = 'New Email Pushed To Draft',
  NEW_EMAIL_SENT = 'New Email Sent',

  // Document type
  DOCUMENT_TYPE_ACTIVATED = 'Document Type Activated',
  DOCUMENT_TYPE_DEACTIVATED = 'Document Type Deactivated',
  DOCUMENT_TYPE_CREATED = 'Document Type Created',
  DOCUMENT_TYPE_CREATED_FROM_SYSTEM = 'Document Type Created From System',
  DOCUMENT_TYPE_UPDATED = 'Document Type Updated',
  DOCUMENT_TYPE_COPIED = 'Document Type Copied',

  // Document Summary

  DOCUMENT_SUMMARY_EXECUTED = 'Document Summary Executed',
  DOCUMENT_SUMMARY_INTERACTED_WITH = 'Document Summary Interacted With',
  DOCUMENT_SUMMARY_TYPE_CHANGED = 'Document Summary Type Changed',
  DOCUMENT_SUMMARY_SAVED = 'Document Summary Saved',
  DOCUMENT_CONTACT_UPDATED = 'Document Contact Updated',

  // Document Prospecting

  DOCUMENT_PROSPECTING_STARTED = 'Document Prospecting Started',
  DOCUMENT_PROSPECTING_FILE_ADDED = 'Document Prospecting File Added',
  DOCUMENT_PROSPECTING_EXTERNAL_SYSTEM_SELECTED = 'Document Prospecting External System Selected',
  DOCUMENT_PROSPECTING_CONTACT_CONFIRMED = 'Document Prospecting Contact Confirmed',
  DOCUMENT_PROSPECTING_FIELDS_CONFIRMED = 'Document Prospecting Fields Confirmed',
  DOCUMENT_PROSPECTING_COMPLETED = 'Document Prospecting Completed',

  // Input parameters hierarchy
  INPUT_PARAMETERS_HIERARCHY_NODE_CREATED = 'Created Input Parameter Hierarchy Node',
  INPUT_PARAMETERS_HIERARCHY_NODE_REMOVED = 'Removed Input Parameter Hierarchy Node',
  INPUT_PARAMETERS_HIERARCHY_NODE_UPDATED = 'Updated Input Parameter Hierarchy Node',

  // Agenda
  AGENDA_SHOW_REVIEW_MODAL_CLICKED = 'Show Agenda Review Modal Clicked',
  AGENDA_TOGGLE_CLICKED = 'Agenda Toggle Clicked',
  AGENDA_ITEM_ADDED = 'Agenda Item Added',
  AGENDA_ITEM_TEXT_UPDATED = 'Agenda Item Text Updated',
  AGENDA_ITEM_STATUS_UPDATED = 'Agenda Item Status Updated',
  AGENDA_ITEM_DELETED = 'Agenda Item Deleted',

  // Academy
  ZOCKS_ACADEMY_CLICKED = 'Zocks Academy Clicked',

  // Cross-Client
  X_CLIENT_OPENED = 'X-Client Opened',
  X_CLIENT_QUERY_SUBMITTED = 'X-Client Query Submitted',
  X_CLIENT_QUERY_CONFIRMED = 'X-Client Query Confirmed',
  X_CLIENT_QUERY_DENIED = 'X-Client Query Denied',
  X_CLIENT_RESULT_READY = 'X-Client Result Ready',
  X_CLIENT_RESULT_EXPORTED = 'X-Client Result Exported',
  X_CLIENT_HISTORY_OPENED = 'X-Client History Opened',

  // Form template

  FORM_TEMPLATE_CREATED = 'Form Template Created',
  FORM_TEMPLATE_FILLED_OUT = 'Form Template Filled Out',

  // Multi Language Support
  CHANGE_MEETING_LANGUAGE_MODAL_CLICKED = 'Change Meeting Language Modal Clicked',
  MULTI_LANGUAGE_SETTING_CHANGED = 'Multi Language setting changed',
  MULTI_LANGUAGE_SETTING_FALLBACK_OPTION_CHANGED = 'Multi Language setting fallback option changed',
  MEETING_LANGUAGE_CONFIRMED = 'Meeting language confirmed',
  MEETING_LANGUAGE_CALCULATED = 'Meeting language calculated',
}

export enum OnboardingTrackEvent {
  ONBOARDING_PRESETS_DONE = 'onboarding-presets-done',
  ZOOM_CONNECTED = 'zoom-connected',
  CALENDAR_CONNECTED = 'calendar-connected',
  DEMO_MEETING_VIEWED = 'demo-meeting-viewed',
  SUMMARY_AGENT_VIDEO_VIEWED = 'summary-agent-video-viewed',
  DISMISS_ONBOARDING_ITEM = 'onboarding-item-dismissed',
  ONBOARDING_PRESETS_DISMISSED = 'onboarding-presets-dismissed',
  ONBOARDING_ZOOM_INTEGRATION_DISMISSED = 'onboarding-zoom-integration-dismissed',
  ONBOARDING_CALENDAR_INTEGRATION_DISMISSED = 'onboarding-calendar-integration-dismissed',
  ONBOARDING_DEMO_MEETING_VIEWED_DISMISSED = 'onboarding-demo-meeting-dismissed',
  ALL_DISMISSED = 'onboarding-all-items-dismissed',
  LIVE_MEETINGS_VIDEO_VIEWED = 'live-meetings-video-viewed',
  WEBEX_CONNECTED = 'webex-connected',
}

export enum AIResultMetadataType {
  COPY = 'copy',
  EMAIL = 'email',
}
